import { render, staticRenderFns } from "./AccountSettingsIdentification.html?vue&type=template&id=0f51cab8&scoped=true&"
import script from "./AccountSettingsIdentification.ts?vue&type=script&lang=ts&"
export * from "./AccountSettingsIdentification.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/account/_settings-identification.scss?vue&type=style&index=0&id=0f51cab8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51cab8",
  null
  
)

export default component.exports